export default "__VITE_ASSET__D78USaCF__"